var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99935 1.19043C3.79102 1.19043 1.16602 3.8096 1.16602 7.03543C1.16602 9.9521 3.30102 12.3729 6.08935 12.8104V8.7271H4.60768V7.03543H6.08935V5.74626C6.08935 4.2821 6.95852 3.4771 8.29435 3.4771C8.93018 3.4771 9.59518 3.58793 9.59518 3.58793V5.02876H8.86018C8.13685 5.02876 7.90935 5.47793 7.90935 5.93876V7.03543H9.53102L9.26852 8.7271H7.90935V12.8104C9.28394 12.5933 10.5356 11.892 11.4385 10.833C12.3413 9.77395 12.8358 8.42706 12.8327 7.03543C12.8327 3.8096 10.2077 1.19043 6.99935 1.19043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ac6395a4dd1dfa560622069b93a6ecdb.svg";
export { ForwardRef as ReactComponent };